import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TranslateService } from '@ngx-translate/core';
import { TOAST_STATE, ToastService } from 'src/app/services/toast.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PHBHPLayoutPackageService {
  importStationsClicked: boolean = false;
  expandedMenu = false;
  showLoader = false;
  showFiltersLoader = false;
  loadingCount: number = 0;
  institutionID: number;
  institutionCountryId: number;
  institutionWebkess: boolean;
  groupID: number;
  institutionIDSubject = new Subject<number>();
  packageID: number;
  packageIDSubject = new Subject<number>();
  kendoChart = new Subject<string>();
  lang = new Subject<string>();
  setActionDate;
  serverUrl = "http://10.1.6.175:8006";
  apiUrl = "http://10.1.6.175:8000/api";
  sopManagementInitMobile = new Subject<number>();
  dashboardSelectedInstitution = 0;
  dashboardSelectedInstitutionName = 'SOP_MANAGEMENT.ALL';
  showSubCategoryLink: boolean = true;
  private readonly appLogoScale = 3;
  private appLogoBase64ByScale = new Map<number, string>();
  private appLogoBase64PromiseByScale = new Map<number, Promise<string>>();


  constructor(private notificationService: NotificationService, public translate: TranslateService,
    private toastService: ToastService, private http: HttpClient) {
      //this.preloadAppLogo();
  }

  public init(): void {
    this.preloadAppLogo();
  }

  objectString(objectChecked) {
    let string = '';
    for (const key in objectChecked) {
      if (objectChecked[key]) { string += ',' + key; }
    }
    return string.substring(1, string.length);
  }

  showError(message, title?) {
    if (!title) title = this.translateText('ERROR_MESSAGES.TOAST.ERROR');
    this.showNotification(message, 'danger', title);
  }

  showSuccess(message, title?) {
    if (!title) title = this.translateText('ERROR_MESSAGES.TOAST.SUCCESS');
    this.showNotification(message, 'success', title);
  }

  showInfo(message, title?) {
    this.showNotification(message, 'info', title);
  }

  showWarning(message, title?) {
    if (!title) title = this.translateText('ERROR_MESSAGES.TOAST.WARNING');
    this.showNotification(message, 'warning', title);
  }

  showNotification(message, messageType, title = '') {
    this.translateText(messageType);

    const toastState = TOAST_STATE[messageType];
    const messageToast = message.toString();
    this.toastService.showToast(
      toastState,
      title,
      messageToast
    );

    // this.notificationService.show({
    //   content: message,
    //   hideAfter: 5000,
    //   position: { horizontal: 'center', vertical: 'top' },
    //   animation: { type: 'fade', duration: 400 },
    //   type: { style: messageType, icon: true }
    // });
  }

  /**
   * Translates any key, static or dynamic (used in Sop and SopSteps multilingual)
   * @param key Key to be translated, can be static (defined at Babel) or dynamic (SOP and SOPSteps multilingual inputs)
   * @param defaultKey When key is not found for any language, including default language, this key is used as default
   * @returns Returns key translation if key is found for selected language. If not, default language ('en') translation is returned. In case key is not found for any language, it returns @defaultKey translation for selected language.
   */
  translateText(key: string, defaultKey: string = null) {
    if (!key) return '';
    const selectedLanguageTranslation = this.translate.instant(key);
    let translatedText = selectedLanguageTranslation;
    const isTranslationMissedForSelectedLanguage = selectedLanguageTranslation == '' && this.translate.currentLang != this.translate.getDefaultLang()
    const isTranslationMissedForAnyLanguage = selectedLanguageTranslation === key;
    if (isTranslationMissedForSelectedLanguage) {
      translatedText = this.translate.store.translations[this.translate.getDefaultLang()][key]
    }
    else if (isTranslationMissedForAnyLanguage && defaultKey) {
      translatedText = this.translate.instant(defaultKey);
    }
    if (translatedText &&
      translatedText.startsWith('SOP_')) translatedText = '';
    return translatedText;
  }

  /**
   * Gets the key for a given value
   * @param value Value to get key for
   * @returns Key for given value
   */
  getTranslationKey(value: string) {
    for (let lang in this.translate.store.translations) {
      for (let key in this.translate.store.translations[lang]) {
        if (this.translate.store.translations[lang][key] === value) {
          return key;
        }
      }
    }
    return null;
  }

  convertUTCDateToLocalDate(date) {
    let newDate = new Date(date);
    if (navigator.userAgent.search('iPad') >= 0 || navigator.userAgent.search('iPhone') >= 0) {
      return newDate;
    } else if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) {
      return newDate;
    } else { // chrome, ie, edge, opera
      const millis = newDate.getTime() - (newDate.getTimezoneOffset() * 60000);
      newDate.setTime(millis);
      return newDate;
    }
  }

  // WIP
  convertFormattedStringToDate(lang, dateString) {
    switch (lang) {
      case 'en':

        break;
      case 'de':
        break;
      // case 'au':
      //   break;
      // case 'ch':
      //   break;
      case 'fr':
        break;
      case 'cs':
        break;
      case 'es':
        break;
      case 'it':
        break;
      case 'nl':
        break;
      case 'hu':
        break;
      case 'sk':
        break;
      case 'ca':
        break;
      case 'pt':
        break;

    }
  }

  convertUTCStingToLocalDate(dateString) {
    return this.convertUTCDateToLocalDate(new Date(dateString));
  }

  /**
   * Applies time offset from local @date to obtain UTC date
   * @param date
   * @returns Date with time zone offset applied
   */
  convertLocalDateToUTC(date: Date) {
    if (!date)
      return null
    var dateUTC = new Date(date)
    dateUTC.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return dateUTC;
  }


  /**
   * Applies time offset from local @date to obtain UTC date
   * @param date
   * @returns Date with time zone offset applied as string
   */
  convertLocalDateToUTCString(date: Date) {
    if (!date)
      return ''
    return this.convertLocalDateToUTC(date).toUTCString();
  }

  getDateForFileName() {
    const currentDate = new Date();
    const month = (currentDate.getMonth() + 1 > 9) ? currentDate.getMonth() + 1 : ('0' + (currentDate.getMonth() + 1));
    const date = (currentDate.getDate() > 9) ? currentDate.getDate() : '0' + currentDate.getDate();
    return `${currentDate.getFullYear()}.${month}.${date}`;
  }

  isMyHygieneSOPLicense(packageID) {
    return packageID == 1 || packageID == 3 || packageID == 5 || packageID == 7;
  }

  isObserveLicense(packageID) {
    return packageID == 2 || packageID == 3 || packageID == 6 || packageID == 7;
  }

  isHygieneCheckLicense(packageID) {
    return packageID == 4 || packageID == 5 || packageID == 6 || packageID == 7;
  }

  getSubCategoryName(subCategory) {
    const countryConfig = subCategory.professionalSubCategoryCountryConfiguration;

    if (!countryConfig) {
      return subCategory.subCategoryName;
    }

    const subcategoriesTranslations = countryConfig.professionalSubcategoriesTranslations;
    if (!subcategoriesTranslations || subcategoriesTranslations.length === 0) {
      return countryConfig.subCategoryName || subCategory.subCategoryName;
    }

    const translation = subcategoriesTranslations.find(trl => trl.lang === this.translate.currentLang);
    return translation ? translation.translation || subCategory.subCategoryName : subCategory.subCategoryName;
  }

  public startLoadingFilter() {
    this.loadingCount++;
    this.showFiltersLoader = true;
  }

  public stopLoadingFilter() {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }
    if (this.loadingCount === 0) {
      this.showFiltersLoader = false;
    }
  }

  async convertSvgToPngBase64(svgUrl: string, scale: number = 2): Promise<string> {
    const svgText = await this.http.get(svgUrl, { responseType: 'text' }).toPromise();

    return new Promise<string>((resolve, reject) => {
      const img = new Image();
      const blob = new Blob([svgText], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const width = img.naturalWidth || img.width || 1;
        const height = img.naturalHeight || img.height || 1;
        canvas.width = width * scale;
        canvas.height = height * scale;
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          URL.revokeObjectURL(url);
          reject('Canvas context not available');
          return;
        }

        ctx.setTransform(scale, 0, 0, scale, 0, 0);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, width, height);

        const pngBase64 = canvas.toDataURL('image/png');
        resolve(pngBase64);

        URL.revokeObjectURL(url);
      };

      img.onerror = reject;
      img.src = url;
    });
  }

  private preloadAppLogo(): void {
    this.getAppLogoBase64(this.appLogoScale).catch(() => {
      // Ignore preload errors; component-level code will fall back to asset path if needed.
    });
  }

  async getAppLogoBase64(scale: number = this.appLogoScale): Promise<string> {
    if (this.appLogoBase64ByScale.has(scale)) {
      return this.appLogoBase64ByScale.get(scale);
    }

    if (!this.appLogoBase64PromiseByScale.has(scale)) {
      const promise = this.convertSvgToPngBase64('assets/img/app-logo.svg', scale)
        .then((logo) => {
          this.appLogoBase64ByScale.set(scale, logo);
          this.appLogoBase64PromiseByScale.delete(scale);
          return logo;
        })
        .catch((error) => {
          this.appLogoBase64PromiseByScale.delete(scale);
          throw error;
        });

      this.appLogoBase64PromiseByScale.set(scale, promise);
    }

    return this.appLogoBase64PromiseByScale.get(scale);
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
